export class Profile {
  constructor(
    public emailAddress: string,
    public firstName: string,
    public lastName: string
  ) {}

  get fullName(): string {
    return `${this.firstName} ${this.lastName}`.trim();
  }
}

export const EmptyProfile = (): Profile => new Profile('', '', '');
